import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import STRINGS from './../../data/language/language';
import Btvoltar from '../../components/buttons/Btvoltar';

import { WS_PAGAMENTO } from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';

const VALIDATE = WS_PAGAMENTO.validateUser;

class FormAcesso extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      ...props.dados,
      strings: STRINGS[window.LANGUAGE],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(){
    const { nome, email, senha, cpf_cnpj, data_nascimento } = this.state;
    const {
      erroValidate,
      atencao,
      preenchaCamposAsterisco,
      emailCadastrado,
      cpfCadastrado,
      cpfEmailCadastrado
    }
    = this.state.strings;
    const self = this;

    if( nome && email && senha && cpf_cnpj && data_nascimento ){
      Requisitions({
        url:VALIDATE,
        data: {email,cpf_cnpj},
        sucess:function(data){

          const emailValidate = data.email;
          const cpfValidate = data.cpf_cnpj;

          if(emailValidate || cpfValidate){

            let msgError;

            if(emailValidate){
              msgError = emailCadastrado;
            }

            if(cpfValidate){
              msgError = cpfCadastrado;
            }

            if(emailValidate && cpfValidate ){
              msgError = cpfEmailCadastrado;
            }

            var msg = {
              title: atencao,
              text: msgError
            };
            Dialog.create(msg);
          }else{
            self.props.changeStep({ step:(self.props.step+1) });
          }
        },
        error:function(data){console.log(data);
          Dialog.create({
            title: atencao,
            text: erroValidate
          });
        }
      });
      //validateUser
      //
    }else{
      const msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };
      Dialog.create(msg);
    }
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    /*if(target.name === 'sexo' && target.value === 'M'){
      const {
        atencao,
        manNotAllowd
      }
      = this.state.strings;

      const msg = {
        title: atencao,
        text: manNotAllowd
      };
      Dialog.create(msg);
      return false;
    }*/

    this.setState({
      [name]: value
    });

    this.props.changeData({name, value});
  }

  render(){
    const strings = this.state.strings;

    return(
      <div  className='box-formulario'>
        <div className='box-title'>
          {/*<span className='cadastro-title'><strong>Cadastro - </strong>1 de 3</span>*/}
          <span className='title-box-title'>{strings.dadosAcesso}</span>
        </div>
        <div>
          <div className='block-sexo'>
            <div className='title-block-sexo'>Sexo*</div>
            <div className='pure-u-12-24'>
              <input
                checked={this.state.sexo==='F'}
                type='radio'
                value='F'
                name='sexo'
                onChange={this.handleInputChange}
              />
              <span className='sexo-txt'>Feminino</span>
            </div>
            <div className='pure-u-12-24'>
              <input
                checked={this.state.sexo==='M'}
                type='radio'
                value='M'
                name='sexo'
                onChange={this.handleInputChange}
              />
              <span className='sexo-txt'>Masculino</span>
            </div>
          </div>
          <TextInput
            value={this.state.nome}
            onChange={this.handleInputChange}
            name="nome"
            title={`${strings.txtNome}*`}
            placeholder={strings.digiteUsuario}>
          </TextInput>
          <TextInput
            value={this.state.cpf_cnpj}
            inputMask={{
              name:'cpf_cnpj',
              placeholder: strings.digiteCpf,
              mask: "999.999.999-99",
              maskChar: "_"
            }}
            onChange={this.handleInputChange}
            name="cpf_cnpj"
            title={`${strings.txtCpf}*`}
            placeholder={strings.digiteCpf}>
          </TextInput>

            <TextInput
              value={this.state.data_nascimento}
              inputMask={{
                name:'data_nascimento',
                placeholder: strings.digiteData,
                mask: "99/99/9999",
                maskChar: "_"
              }}
              onChange={this.handleInputChange}
              name="data_nascimento"
              title={`${strings.txtDataNasc}*`}
              placeholder={strings.digiteData}>
            </TextInput>
            {/*<TextInput
              value={this.state.telefone}
              inputMask={{
                name:'telefone',
                placeholder: strings.digiteTel,
                mask: "(99) 99999-9999",
                maskChar: "_"
              }}
              onChange={this.handleInputChange}
              name="telefone"
              title={`${strings.txtTel}*`}
              placeholder={strings.digiteTel}>
            </TextInput>
          */}
          <TextInput
            value={this.state.email}
            onChange={this.handleInputChange}
            name="email"
            title={`${strings.txtEmailCadastro}*`}
            placeholder={strings.digiteEmail}>
          </TextInput>
          <TextInput
            value={this.state.senha}
            onChange={this.handleInputChange}
            name="senha"
            type='password'
            title={`${strings.txtSenha}*`}
            placeholder={strings.digiteSenha}>
          </TextInput>
          <div className='field-mandatory'>{strings.camposObrigatorios}</div>
          <div className="box-center-button">
            <Button text={strings.txtContinuar} onClick={this.handleSubmit} type='button' classes="button-login simple-button" />
            <br />
            <br />
        </div>
        </div>
      </div>
    )
  }
}

export default FormAcesso;



// WEBPACK FOOTER //
// ./src/classes/cadastro/FormAcesso.js